import { get } from 'lodash';
import { reject, resolve } from 'redux-optimist-promise';
import { FETCH_ADDITIONAL_TRANSPORTS } from 'Store/booking/additional-transports/additionalTransports.action';
import { FETCH_PROPOSALS_BY_ID } from 'Store/booking/proposals/constants';
type State = boolean;
const initialState: State = false;

function isLoadingReducer(
  state: State = initialState,
  action: Action<any> | null | undefined,
): State {
  switch (get(action, 'type')) {
    case FETCH_ADDITIONAL_TRANSPORTS:
    case FETCH_PROPOSALS_BY_ID:
      return true;

    case resolve(FETCH_ADDITIONAL_TRANSPORTS):
    case reject(FETCH_ADDITIONAL_TRANSPORTS):
    case resolve(FETCH_PROPOSALS_BY_ID):
    case reject(FETCH_PROPOSALS_BY_ID):
      return false;

    default:
      return state;
  }
}

export default isLoadingReducer;
